
import React from "react";
import { MobileTooltipWrapper } from "@/components/ui/tooltip";
import { Printer, Settings, Zap, Wrench, ShoppingCart } from "lucide-react";

interface ComplexityCellProps {
  requiresRoot: boolean;
  requiresWiring?: boolean;
  requiresPrinting?: boolean;
  requiresTools?: boolean;
  requiresPurchase?: boolean;
}

const ComplexityCell = ({ 
  requiresRoot, 
  requiresWiring = false, 
  requiresPrinting = false, 
  requiresTools = false, 
  requiresPurchase = false 
}: ComplexityCellProps) => {
  // Define inactive color - use specific override class
  const inactiveColor = "text-gray-400 dark:text-gray-600 requirement-inactive";
  
  // Define wiring color that changes based on light/dark mode
  const wiringColor = "text-amber-700 dark:text-yellow-400";
  
  return (
    <div className="flex gap-0.5 justify-center">
      <MobileTooltipWrapper content={requiresRoot ? "Root access is needed" : "No root access needed"}>
        <div className={`inline-flex items-center text-xs ${requiresRoot ? "text-red-500" : "text-gray-500 dark:text-gray-500 requirement-inactive"}`}>
          <Settings size={16} />
        </div>
      </MobileTooltipWrapper>
      
      <MobileTooltipWrapper content={requiresWiring ? "Requires wiring" : "No wiring required"}>
        <div className={`inline-flex items-center text-xs ${requiresWiring ? wiringColor : inactiveColor}`}>
          <Zap size={16} />
        </div>
      </MobileTooltipWrapper>
      
      <MobileTooltipWrapper content={requiresPrinting ? "Requires printed parts" : "No printed parts required"}>
        <div className={`inline-flex items-center text-xs ${requiresPrinting ? "text-blue-500" : inactiveColor}`}>
          <Printer size={16} />
        </div>
      </MobileTooltipWrapper>
      
      <MobileTooltipWrapper content={requiresTools ? "Requires tools" : "No additional tools required"}>
        <div className={`inline-flex items-center text-xs ${requiresTools ? "text-purple-600" : inactiveColor}`}>
          <Wrench size={16} />
        </div>
      </MobileTooltipWrapper>
      
      <MobileTooltipWrapper content={requiresPurchase ? "Requires purchase" : "No purchased parts required"}>
        <div className={`inline-flex items-center text-xs ${requiresPurchase ? "text-lime-600 dark:text-green-400" : inactiveColor}`}>
          <ShoppingCart size={16} />
        </div>
      </MobileTooltipWrapper>
    </div>
  );
};

export default ComplexityCell;
